// Schema of editable copy fields, grouped by section.
// path = dot-notation within a language object (e.g. "hero.title")
// type = "text" | "textarea"
export const COPY_SCHEMA = [
    {
        section: "Header / Nav",
        keys: [
            { path: "nav.mission", type: "text" },
            { path: "nav.program", type: "text" },
            { path: "nav.news", type: "text" },
            { path: "nav.events", type: "text" },
            { path: "nav.partners", type: "text" },
            { path: "nav.results", type: "text" },
            { path: "nav.team", type: "text" },
            { path: "nav.help", type: "text" },
            { path: "nav.donate", type: "text", note: "Header CTA button" },
        ],
    },
    {
        section: "Hero",
        keys: [
            { path: "hero.kicker", type: "text", note: "Small text above title (Brussels · Non-Profit Foundation)" },
            { path: "hero.title", type: "text", note: "First part of the H1 (white)" },
            { path: "hero.titleAccent", type: "text", note: "Second part of the H1 (yellow)" },
            { path: "hero.subtitle", type: "textarea" },
            { path: "hero.cta_primary", type: "text", note: "Yellow button" },
            { path: "hero.cta_secondary", type: "text", note: "Ghost button" },
            { path: "hero.stat1.value", type: "text", note: "Big number, e.g. 9.8%" },
            { path: "hero.stat1.label", type: "text" },
            { path: "hero.stat2.value", type: "text" },
            { path: "hero.stat2.label", type: "text" },
            { path: "hero.stat3.value", type: "text" },
            { path: "hero.stat3.label", type: "text" },
        ],
    },
    {
        section: "Marquee Strip",
        keys: [{ path: "marquee", type: "text", note: "Scrolling banner text under the hero" }],
    },
    {
        section: "Mission",
        keys: [
            { path: "mission.label", type: "text" },
            { path: "mission.title", type: "text" },
            { path: "mission.body1", type: "textarea" },
            { path: "mission.body2", type: "textarea" },
            { path: "mission.body3", type: "textarea" },
            { path: "mission.quote", type: "textarea", note: "Big pull-quote" },
            { path: "mission.quoteAuthor", type: "text" },
        ],
    },
    {
        section: "Program (Wat doen wij?)",
        keys: [
            { path: "program.label", type: "text" },
            { path: "program.title", type: "text" },
            { path: "program.steps.0.title", type: "text", note: "Step 01 title" },
            { path: "program.steps.0.body", type: "textarea" },
            { path: "program.steps.1.title", type: "text", note: "Step 02 title" },
            { path: "program.steps.1.body", type: "textarea" },
            { path: "program.steps.2.title", type: "text", note: "Step 03 title" },
            { path: "program.steps.2.body", type: "textarea" },
        ],
    },
    {
        section: "Results (Impact)",
        keys: [
            { path: "impact.label", type: "text" },
            { path: "impact.title", type: "text" },
            { path: "impact.body", type: "textarea" },
        ],
    },
    {
        section: "News section header",
        keys: [
            { path: "news.label", type: "text" },
            { path: "news.title", type: "text" },
            { path: "news.read_more", type: "text" },
            { path: "news.view_all", type: "text" },
        ],
    },
    {
        section: "Events section header",
        keys: [
            { path: "events.label", type: "text" },
            { path: "events.title", type: "text" },
            { path: "events.read_more", type: "text" },
            { path: "events.upcoming", type: "text", note: "Badge on each event card" },
        ],
    },
    {
        section: "Partners",
        keys: [
            { path: "partners.label", type: "text" },
            { path: "partners.title", type: "text" },
            { path: "partners.cta", type: "text", note: "Button under the partner list" },
        ],
    },
    {
        section: "Team",
        keys: [
            { path: "team.label", type: "text" },
            { path: "team.title", type: "text" },
        ],
    },
    {
        section: "Inspiration (Constant Vanden Stock)",
        keys: [
            { path: "legacy.label", type: "text" },
            { path: "legacy.title", type: "text" },
            { path: "legacy.body1", type: "textarea" },
            { path: "legacy.body2", type: "textarea" },
            { path: "legacy.body3", type: "textarea" },
            { path: "legacy.cruyff_quote", type: "textarea" },
            { path: "legacy.cruyff_author", type: "text" },
            { path: "legacy.cruyff_context", type: "textarea" },
            { path: "legacy.body4", type: "textarea" },
            { path: "legacy.body5", type: "textarea" },
            { path: "legacy.body6", type: "textarea" },
            { path: "legacy.body7", type: "textarea" },
            { path: "legacy.steegen_quote", type: "textarea" },
            { path: "legacy.steegen_author", type: "text" },
        ],
    },
    {
        section: "Donate (Hoe kan u helpen?)",
        keys: [
            { path: "donate.label", type: "text" },
            { path: "donate.title", type: "text" },
            { path: "donate.subtitle", type: "textarea" },
            { path: "donate.kbf_eyebrow", type: "text" },
            { path: "donate.kbf_headline", type: "text" },
            { path: "donate.kbf_body", type: "textarea" },
            { path: "donate.kbf_cta", type: "text" },
            { path: "donate.iban_label", type: "text" },
        ],
    },
    {
        section: "Contact",
        keys: [
            { path: "contact.label", type: "text" },
            { path: "contact.title", type: "text" },
            { path: "contact.name", type: "text" },
            { path: "contact.email", type: "text" },
            { path: "contact.company", type: "text" },
            { path: "contact.message", type: "text" },
            { path: "contact.send", type: "text" },
            { path: "contact.success", type: "text" },
            { path: "contact.error", type: "text" },
        ],
    },
    {
        section: "Footer",
        keys: [
            { path: "footer.tagline", type: "text" },
            { path: "footer.rights", type: "text" },
            { path: "footer.iban", type: "text", note: "Label before the IBAN number" },
            { path: "footer.newsletter_eyebrow", type: "text" },
            { path: "footer.newsletter_heading", type: "text" },
            { path: "footer.newsletter_placeholder", type: "text" },
            { path: "footer.newsletter_consent", type: "textarea" },
            { path: "footer.newsletter_cta", type: "text" },
            { path: "footer.newsletter_success", type: "text" },
            { path: "footer.newsletter_already", type: "text" },
            { path: "footer.newsletter_error", type: "text" },
        ],
    },
    {
        section: "Why Sport (section labels)",
        keys: [
            { path: "why.label", type: "text" },
            { path: "why.title", type: "text" },
            { path: "why.intro", type: "textarea" },
            { path: "why.read_full", type: "text" },
            { path: "why.manifesto_intro", type: "textarea", note: "Shown at the top of /why-sport" },
        ],
    },
    {
        section: "Activities section header",
        keys: [
            { path: "activities.label", type: "text" },
            { path: "activities.title", type: "text" },
            { path: "activities.visit", type: "text" },
        ],
    },
];

// Read a nested value by dot-path from an object (supports numeric indexes for arrays)
export function readPath(obj, path) {
    if (!obj) return "";
    const parts = path.split(".");
    let cur = obj;
    for (const p of parts) {
        if (cur == null) return "";
        const idx = /^\d+$/.test(p) ? parseInt(p, 10) : p;
        cur = cur[idx];
    }
    return cur == null ? "" : String(cur);
}
